export default "__VITE_ASSET__CDAeAuHD__"